// removed by extract-text-webpack-plugin
module.exports = {"benefits":"Benefits__benefits__2Fy_4","hasAnimation":"Benefits__hasAnimation__16uFn","benefits-fade-in":"Benefits__benefits-fade-in__3XF4n","title":"Benefits__title__2-Lmd","benefit":"Benefits__benefit__zZ0qY","icon":"Benefits__icon__2Q_4K","text":"Benefits__text__bSi_3"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Sidebar/styles/Benefits.scss
// module id = 3059
// module chunks = 4